export const blockIconsContentAddCircleOutline = (
	<span className='material-symbols-outlined'>add_circle_outline</span>
);
